
export const fillzero = (n) => {
  return n < 10 ? '0' + n : '' + n
}



// WEBPACK FOOTER //
// ./src/filters/fillzero.js